module.exports = __webpack_public_path__ + "static/media/phone.596d057f.png";